// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CollectionCategories_Wrapper__xam3_"};